import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { NdtHubConnectionService } from '../ndt-hub-connection.service';

@Injectable({ providedIn: 'root' })
export abstract class NdtHubBase implements OnDestroy {
   destroyed = new Subject<void>();

   constructor(public ndtHubService: NdtHubConnectionService) {
      this.ndtHubService.onBeforeConnected$.pipe(takeUntil(this.destroyed)).subscribe(() => {
         this.wireUpHubEvents();
      });
   }

   ngOnDestroy(): void {
      this.destroyed.next();
   }

   abstract wireUpHubEvents(): void;
}
